import React, { useState, useEffect } from 'react';
import {
  Grid,
  Button,
  Column,
  DataTable,
  Link,
  Modal,
  Pagination,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  RadioButton,
  RadioButtonGroup,
  Theme,
} from '@carbon/react';
import { getResoucesForViews,
   getSupplierAdditionalTaxInformation,
   getSupplierTaxAttachment } from '../../services/services';
import CommodityHeader from '../../components/Header';
import { useNavigate } from "react-router-dom";

const headers = [
  {
    key: 'ctrycode',
    header: 'Country',
  },
  {
    key: 'supplierNumber',
    header: 'Supplier Number',
  },
  {
    key: 'latestUpload',
    header: 'Latest Upload',
  },
  {
    key: 'moreInformation',
    header: 'Click for More Information',
  }
];

const modalHeaders = [
  {
    key: 'index',
    header: 'Index',
  },
  {
    key: 'uploadedBy',
    header: 'User',
  },
  {
    key: 'date',
    header: 'Date of Upload',
  }
];


const TaxCondition = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [moreInformationModal, setMoreInformationModal] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowsAux, setRowsAux] = useState([]);
  const [moreInfo, setMoreInfo] = useState([]);
  const [ctrySuppNumb, setCtrySuppNumb] = useState([]);
  const [linksGenerated, setLinksGenerated] = useState([]);

  const changePaginationState = (pageInfo) => {
    if (page !== pageInfo.page) {
      setPage(pageInfo.page)
    }
    if (pageSize !== pageInfo.pageSize) {
      setPageSize(pageInfo.pageSize)
    }
  }

  const openModal = (rowData) => {
    let request = {};
    request.ctrycode = rowData.cells[0].value;
    request.suppnumb = rowData.cells[1].value;
    request.active = true;
    getTaxCondition(request); //cells0 y cells1 son ctrycode y suppnumb respectivamente
    setMoreInformationModal(true);
  };

  const closeModal = () => {
    setMoreInformationModal(false);
    setCtrySuppNumb([]);
    setMoreInfo([]);
    setLinksGenerated([]);
  };

  const goHomeScreen = () => {
    navigate('/home')
  };

  const getTaxCondition = async (request) => await getSupplierAdditionalTaxInformation(request)
  .then(response => {
    if(response.status === 200){
      response.json()
        .then(response => {
          parserTaxConditionAtt(response);
        })
    }    
  });      

  const getAllTaxCondition = async (request) => await getResoucesForViews(request)
  .then(response => {
    if(response.status === 200){
      response.json()
        .then(response => {
          parserIdInResponse(response);
        })
    }    
  });    
    
  const parserIdInResponse = (response) => {
    const resParsed = response.map((res, i) => {
      const parsed = {};
      parsed["id"] = i.toString();
      parsed["ctrycode"] = res.pk.country;
      parsed["supplierNumber"] = res.pk.supplierNumber;
      parsed["latestUpload"] = res.latestUpload;
      return parsed;
    });
    setRows(resParsed);
    setRowsAux(resParsed);
  };

  const parserTaxConditionAtt = (response) => {
    const linkElements = [];
    for (let i = 0; i < response.listSupplierAttachmentInfo.length; i++) {
      linkElements.push(
        <Link key={i} onClick={() => download(response.listSupplierAttachmentInfo[i])}>
          {"Download "}{i + 1}{" "}
        </Link>
      );
    }
    setLinksGenerated(linkElements);
    const resParsed = response.listSupplierAttachmentInfo.map((res, i) => {
      const parsed = {};
      parsed["id"] = i.toString();
      parsed["index"] = res.index;
      parsed["latestUpload"] = res.latestUpload;
      parsed["uploadedBy"] = res.uploadedBy;
      parsed["date"] = res.date;
      return parsed;
    });
    setMoreInfo(resParsed);
      const parsed = {};
      parsed["ctrycode"] = response.listSupplierAttachmentInfo[0].ctrycode;
      parsed["suppnumb"] = response.listSupplierAttachmentInfo[0].suppnumb;
    setCtrySuppNumb(parsed);
  };

  const download = (item) => {
    let request = {};
    request.ctrycode = item.ctrycode;
    request.suppnumb = item.suppnumb.trim();
    request.index = item.index;
    downloadTaxAttachment(request);
  };

  const downloadTaxAttachment = async (request) => getSupplierTaxAttachment(request)
  .then(response => {
    console.log(response);
    response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = response.headers.get('content-disposition');
        a.click();
    });
  });

  function loadTable(type) {
    if (type === "active") {
      setRows(rowsAux);
    } else if (type === "archived") {
      setRows([]); //no functionality due to lack of definition
    }
  };

  useEffect(() => {
    let request = {};
    request.viewName = 'taxCondition';
    getAllTaxCondition(request);    
  }, [0]);

  return (
    <>
      <h2 className="table-title">Tax Condition</h2>
      <Grid>
        <Theme theme="g90">
          <CommodityHeader />
        </Theme>
        
        <Modal
          className="onboarding-modal"
          focusTrap={false}
          hasscrollingcontent="false"
          iconDescription="Close the modal"
          aria-label="Tax Condition Information"
          modalAriaLabel="Tax Condition Information"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={closeModal}
          onRequestSubmit={closeModal}
          onSecondarySubmit={closeModal}
          open={moreInformationModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="OK"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel={<p><strong>Tax Condition Information</strong></p>}
        >

          <Grid>
            <Column lg={16}>
            
              <Table>
                <TableRow>
                  <TableCell> <p className=""><strong>Country: </strong></p></TableCell>
                  <TableCell> <p className> {ctrySuppNumb.ctrycode} </p></TableCell>
                  <TableCell> <p className=""><strong>Supplier Number: </strong></p></TableCell>
                  <TableCell> <p className> {ctrySuppNumb.suppnumb} </p></TableCell>
                  <TableCell> <p className=""><strong>Download links: </strong></p></TableCell>
                  <TableCell>
                    <Column className="style-column-links-download">
                      {linksGenerated}
                    </Column>
                  </TableCell>
                </TableRow>
              </Table>
            </Column>
          </Grid>
          <Column className="column-table-RTV-log">
          
            <DataTable
              isSortable="true"
              rows={moreInfo}
              headers={modalHeaders}
              render={({
                rows,
                headers,
                getHeaderProps,
                getRowProps,
                getTableProps
              }) => (
                <TableContainer>
                  <Table {...getTableProps()} useZebraStyles>
                    <TableHead>
                      <TableRow>
                        {headers.map(header => (
                          <TableHeader {...getHeaderProps({ header })}>
                            {header.header}
                          </TableHeader>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row) => (
                        <TableRow {...getRowProps({ row })}>
                          {row.cells.map(cell => (
                            <>
                              {cell.id.includes("comments") || cell.id.includes("reason") ? (
                                <TableCell className='style-size-column-modal-rtvlog' key={cell.id}>{cell.value === "" ? ("Empty") : (cell.value)}</TableCell>

                              ) : (
                                <TableCell className='style-size-column-modal-rtvlog2' key={cell.id}>{cell.value === "" ? ("Empty") : (cell.value)}</TableCell>

                              )}

                            </>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            />
          </Column>
        </Modal >
      </Grid >
      <Grid>
        <Column lg={16} >
          <Button className='style-bttbackID' size="lg" style={{marginBottom: '20px'}} onClick={goHomeScreen}>Back to Home</Button>          
          <DataTable
            isSortable="true"
            rows={rows}
            headers={headers}
            render={({
              rows,
              headers,
              getHeaderProps,
              getRowProps,
              getTableProps,
              onInputChange
            }) => (

              <TableContainer>

                <RadioButtonGroup legendText={<p><strong>Select</strong></p>} name="select-radio-button" defaultSelected="radio-1">
                  <RadioButton labelText="Active" onClick={()=>loadTable("active")} value="radio-1" id="radio-1" />
                  <RadioButton labelText="Archived" onClick={()=>loadTable("archived")} value="radio-2" id="radio-2" />
                </RadioButtonGroup>
                {/* <p className="table-content-title"><strong>Click on a row to see more information.</strong></p> */}
                <TableToolbar>
                  <TableToolbarContent>
                    <TableToolbarSearch persistent size="sm" onChange={onInputChange} />
                    {/* pass in `onInputChange` change here to make filtering work */}
                  </TableToolbarContent>
                </TableToolbar>
                <Table {...getTableProps()} useZebraStyles>
                  <TableHead>
                    <TableRow>
                      {headers.map(header => (
                        <TableHeader {...getHeaderProps({ header })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.slice((page - 1) * pageSize).slice(0, pageSize).map((row, i) => (
                      <TableRow {...getRowProps({ row })}>
                        {row.cells.map((cell, i) => (
                          <>
                            {(i + 1 === row.cells.length) ?
                              (<TableCell>
                                <Button
                                  kind="ghost"
                                  size="sm"
                                  className="approve-button"
                                  onClick={() => openModal(row)}
                                >
                                  More Information
                                </Button>
                              </TableCell>)
                              : (<TableCell key={cell.id}>{cell.value}</TableCell>)
                            }
                          </>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Pagination
                  onChange={changePaginationState}

                  backwardText="Previous page"
                  forwardText="Next page"
                  itemsPerPageText="Items per page:"
                  page={page}
                  pageNumberText="Page Number"
                  pageSize={pageSize}
                  pageSizes={[
                    10,
                    25,
                    50,
                    100,
                  ]}
                  totalItems={rows.length}
                />
              </TableContainer>
            )}
          />


        </Column>
      </Grid>
    </>
  );
};

export default TaxCondition;